import { useRouter } from "next/router";
import { useEffect } from "react";
import { getPosthog } from "src/lib/post-hog";
import { isWorkspaceInvitationPath } from "src/features/workspace-members/invite-model";

export function usePageView() {
  const router = useRouter();

  useEffect(() => {
    let active = true;
    const handler = (url = window.location.pathname) => {
      if (isWorkspaceInvitationPath(url)) return;
      void getPosthog().then((ph) => {
        if (active && !isWorkspaceInvitationPath(window.location.pathname)) {
          ph?.capture("$pageview");
        }
      });
    };
    handler();
    router.events.on("routeChangeComplete", handler);
    return () => {
      active = false;
      router.events.off("routeChangeComplete", handler);
    };
  }, [router.events]);
}
